// extracted by mini-css-extract-plugin
module.exports = {"Bio":"ProfilePage_Bio__16zjx","Username":"ProfilePage_Username__24dgm","ProfileCol":"ProfilePage_ProfileCol__HAP1r","InfiniteScroll":"ProfilePage_InfiniteScroll__xf7te"};